import React from 'react';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';
import { Typography } from '@saucelabs/ds-typography/lib';

import { FileIcon } from '../../file';

type TableCellNameProps = {
  group: appStorageRecords.AppStorageGroup,
};

const TableCellName: React.FC<TableCellNameProps> = ({ group }) => {
  const name = group.recent.getDisplayName();

  return (
    <div className="flex flex-row">
      <FileIcon
        alt="app icon"
        className="h-5 w-5"
        file={group.recent}
      />
      <Typography
        className="min-w-34.75 ml-1 text-high-emphasis font-semibold break-words"
        data-qa="app-management-groups-table-cell-name-label"
      >
        {name}
      </Typography>
    </div>
  );
};

export default TableCellName;
